import React from 'react';
import styles from './social.module.scss';

export default ({ socialMedia }) =>
  <div>
    {socialMedia.map(({ url, network }, index) =>
      <a
        href={url}
        target="_blank"
        className={styles.account}
        key={index}
      >
        <i className={`fa fa-${network}`}></i>
      </a>
    )}
  </div>



// WEBPACK FOOTER //
// ./src/components/social.js